import "UI/Widget/Form";
import "Glonass/UI/MenuItem";
NS("Glonass.UI");

Glonass.UI.MenuForm = Class(UI.Widget.Form, {
    formTemplate: "Glonass/MenuForm/Form",

    title: "Меню",

    showTitle: false,

    styles: ["form__splash"],

    $items: null,
    items: {},

    render: function() {
        this.ParentCall();

        this.$items = this.$name("items");

        this.addItems();

        return this;
    },

    addItems: function() {
        this.addItem("admin", "Управление", "gl-menu__color_admin", "icon-cogs", "Security.UI.Admin");

        return this;
    },

    addItem: function(name, title, color, icon, securityKey) {
        if (securityKey && !check(securityKey, Security.AccessMode.View)) {
            return null;
        }

        this.items[name] = new Glonass.UI.MenuItem(this, {
            name: name,
            color: color,
            icon: icon,
            title: title
        }).
        render().appendTo(this.$items).on("click", this.onMenuItemClick, this);

        return this.items[name];
    },

    onMenuItemClick: function(args) {
        this.emit("menuItemClick", {
            name: args.item.name
        });
    }
});
